// extracted by mini-css-extract-plugin
export default {"products":"Xt-z","card":"Yt-z","oosMessaging":"Zt-z"};